import React, { useState, ReactElement } from 'react';
import { Modal, Button, FormItem, Fieldset, Input, Alert } from 'elmo-elements';

export interface ManualModalProps {
  isOpened: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  onBack?: () => void;
  isLoading?: boolean;
  error?: string | null;
}

const ManualModal = ({
  isOpened,
  onClose,
  onSave,
  onBack,
  isLoading = false,
  error = null,
}: ManualModalProps): ReactElement => {
  const [name, setName] = useState('');
  const [nameStatus, setNameStatus] = useState<'default' | 'error'>('default');

  const handleSave = () => {
    if (!name.trim()) {
      setNameStatus('error');
      return;
    }
    onSave(name.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && name.trim()) {
      handleSave();
    }
  };

  const handleClose = () => {
    setName('');
    setNameStatus('default');
    onClose();
  };

  return (
    <Modal
      id="ManualModal"
      className="new-module"
      isOpened={isOpened}
      title="New Module"
      closeModal={handleClose}
      primaryButton={
        <div className="new-module__footer-actions">
          {onBack && (
            <Button type="default" isUppercase={false} onClick={onBack}>
              Back
            </Button>
          )}
          <Button
            type="primary"
            isUppercase={false}
            isLoading={isLoading}
            isDisabled={isLoading}
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      }
    >
      <Fieldset>
        <FormItem
          label="Module Name *"
          status={nameStatus}
          message={nameStatus === 'error' ? 'Please enter a module name' : ''}
        >
          <Input
            id="input-new-module-name"
            value={name}
            onChange={(e: any) => {
              setName(e.target.value);
              setNameStatus('default');
            }}
            onKeyDown={handleKeyDown}
            autoComplete="off"
          />
        </FormItem>
      </Fieldset>
      {error && <Alert type="danger" message={error} />}
    </Modal>
  );
};

export default ManualModal;
